import config from '../config';

function getWalletType() {
  const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
  const isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
  const isDesktop = !isAndroid && !isIOS;

  if (isAndroid) return 'android';
  if (isIOS) return 'ios';
  if (isDesktop) return 'unknown';
}

const getQueryParam = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
};

const calculateLocatinVars = (pathname) => {
  const realPath = pathname
    .replace(new RegExp('^' + config.basename), '')
    .replace(/^\/|\/$/g, '');
  return realPath.split('/');
};

export {
  getWalletType,
  getQueryParam,
  calculateLocatinVars
};